import { Routes } from "../routes"

const isBrowser = () => typeof window !== "undefined"

export const ProtectedRoute = ({ router, token, children }: any) => {
  const pathIsProtected = () => {
    // this captures /meetings as well
    if (router.pathname == "/me" || router.pathname == "/me/") {
      return true
    }

    // moved rediret back to /check controller because it raises Can't perform a React state update on an unmounted component warning.
    // all the protected routes above raise the same warning
    return false
  }

  if (isBrowser() && !token && pathIsProtected()) {
    router.push(Routes.Login)
  }

  return children
}
